import { render, staticRenderFns } from "./InternationalizationTime.vue?vue&type=template&id=51e4ef0e"
import script from "./InternationalizationTime.vue?vue&type=script&lang=js"
export * from "./InternationalizationTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports